/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CriteriaForRouteRequest
 */
export interface CriteriaForRouteRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteRequest
     */
    arrivalCityCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteRequest
     */
    arrivalCountryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteRequest
     */
    arrivalRegionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteRequest
     */
    arrivalStationCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteRequest
     */
    departureCityCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteRequest
     */
    departureCountryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteRequest
     */
    departureRegionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForRouteRequest
     */
    departureStationCode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForRouteRequest
     */
    exclude?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForRouteRequest
     */
    isOutbound?: boolean | null;
}

export function CriteriaForRouteRequestFromJSON(json: any): CriteriaForRouteRequest {
    return CriteriaForRouteRequestFromJSONTyped(json, false);
}

export function CriteriaForRouteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaForRouteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'arrivalCityCode': !exists(json, 'arrivalCityCode') ? undefined : json['arrivalCityCode'],
        'arrivalCountryCode': !exists(json, 'arrivalCountryCode') ? undefined : json['arrivalCountryCode'],
        'arrivalRegionCode': !exists(json, 'arrivalRegionCode') ? undefined : json['arrivalRegionCode'],
        'arrivalStationCode': !exists(json, 'arrivalStationCode') ? undefined : json['arrivalStationCode'],
        'departureCityCode': !exists(json, 'departureCityCode') ? undefined : json['departureCityCode'],
        'departureCountryCode': !exists(json, 'departureCountryCode') ? undefined : json['departureCountryCode'],
        'departureRegionCode': !exists(json, 'departureRegionCode') ? undefined : json['departureRegionCode'],
        'departureStationCode': !exists(json, 'departureStationCode') ? undefined : json['departureStationCode'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'isOutbound': !exists(json, 'isOutbound') ? undefined : json['isOutbound'],
    };
}

export function CriteriaForRouteRequestToJSON(value?: CriteriaForRouteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'arrivalCityCode': value.arrivalCityCode,
        'arrivalCountryCode': value.arrivalCountryCode,
        'arrivalRegionCode': value.arrivalRegionCode,
        'arrivalStationCode': value.arrivalStationCode,
        'departureCityCode': value.departureCityCode,
        'departureCountryCode': value.departureCountryCode,
        'departureRegionCode': value.departureRegionCode,
        'departureStationCode': value.departureStationCode,
        'exclude': value.exclude,
        'isOutbound': value.isOutbound,
    };
}


